var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_c('v-spacer'),_c('div',{staticClass:"action"},[_vm._t("action")],2)],1),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }